import React, {useState, useEffect} from 'react';
import LandHeader from './LandHeader';
// import { MdAttachEmail } from "react-icons/md";
import maskphoto2 from '../../assets/Images/Mask group.png'
import logo from '../../assets/Images/logo rev.png';
import curve from '../../assets/Images/Rectangle 3772.png';
import { BiSolidQuoteAltRight } from "react-icons/bi";
import { BiSolidQuoteAltLeft } from "react-icons/bi";
import locationimg from '../../assets/Images/location_10926781 1.png';
import phone from '../../assets/Images/paycheck_10926363.png';
import chat from '../../assets/Images/information_10985145 1.png';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BiRightArrowAlt } from "react-icons/bi";
import './LandContact.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { IoMdClose } from "react-icons/io";
import { IoIosClose } from "react-icons/io";
import { RiArrowDropDownLine } from "react-icons/ri";
import {  Switch } from '@mui/material';
import { styled } from '@mui/material/styles';


function LandContact() {
  const baseURL =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;

   const [email, setEmail] = useState('');
    const location = useLocation();
       const [menuOpen, setMenuOpen] = useState(false);
       const navigate = useNavigate("");
         const [showpopup, setShowPopup] = useState(false);
                const [isExpanded, setIsExpanded] = useState(false);
                 const [isOpen, setIsOpen] = useState(false);
                  const [isOpen2, setIsOpen2] = useState(false);
                  const [showBanner, setShowBanner] = useState(false);
                  const [nonNecessaryEnabled, setNonNecessaryEnabled] = useState(true);
   
       const toggleMenu = () => {
       setMenuOpen(!menuOpen);
     };
     
      useEffect(() => {
         const consent = localStorage.getItem("cookieConsent");
         if (!consent) {
           setShowBanner(true); // show banner for first-time users
         } else {
           const parsedConsent = JSON.parse(consent);
           setNonNecessaryEnabled(parsedConsent.nonNecessaryEnabled);
           if (!parsedConsent.nonNecessaryEnabled) {
             setShowBanner(true); // show banner if user disabled cookies
           } else {
             setShowBanner(false);
           }
         }
       }, []);
       
       const handleAccept = () => {
         localStorage.setItem(
           "cookieConsent",
           JSON.stringify({ nonNecessaryEnabled: true })
         );
         setNonNecessaryEnabled(true);
         setShowBanner(false);
       };
       
       const handleSaveExit = () => {
         localStorage.setItem(
           "cookieConsent",
           JSON.stringify({ nonNecessaryEnabled })
         );
       
         if (nonNecessaryEnabled) {
           setShowBanner(false); // hide if enabled
         } else {
           setShowBanner(true); // show if disabled
         }
         setShowPopup(false);
       };
        const content = `This website uses cookies to improve your experience while
        you navigate through the website. Out of these cookies, the cookies that are categorized as necessary 
        are stored on your browser as they are as essential for the working of basic functionalities of the 
        website. We also use third-party cookies that help us analyze and understand how you use this website.
         These cookies will be stored in your browser only with your consent. You also have the option to
          opt-out of these cookies. But opting out of some of these cookies may have an effect on your browsing
           experience.`;
     
           const toggleReadMore = () => {
         setIsExpanded(!isExpanded);
       };
       const toggleContent = () => {
         setIsOpen2(false);
         setIsOpen(!isOpen);
         
       }
     
       const toggleContent2 = () => {
         setIsOpen(false)
         setIsOpen2(!isOpen2)
         
       }
     
       const handleClose = () => {
         setShowPopup(false);
       }
     
       const CustomSwitch = styled((props) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(
         ({ theme }) => ({
           width: 60,
           height: 25,
           padding: 0,
           display: 'flex',
           marginLeft:10,
           '& .MuiSwitch-switchBase': {
             padding: 4,
             '&.Mui-checked': {
               transform: 'translateX(26px)',
               color: '#009F0B',
               '& + .MuiSwitch-track': {
                 backgroundColor: '#009F0B',
                 '&:before': {
                   left: 8,
                 },
               },
             },
           },
           '& .MuiSwitch-thumb': {
             boxShadow: '0 2px 4px 0 rgb(0 0 0 / 20%)',
             width: 19,
             height: 19,
             borderRadius: '50%',
             backgroundColor: '#D9D9D9',
             marginLeft:5,
           },
           '& .MuiSwitch-track': {
             position: 'relative',
             borderRadius: 34 / 2,
             backgroundColor: 'grey',
             transition: theme.transitions.create(['background-color'], {
               duration: 500,
             }),
             '&:before': {
               position: 'absolute',
               top: '50%',
               transform: 'translateY(-50%)',
               left: 34,
               color: 'white',
               fontSize: 12,
               fontWeight: 600,
             },
           },
         })
       );
     
       const cookiePopup = () => {
         setShowPopup(true);
       }
     
  
     const handlePricingClick = async () => {
      if (!email) {
        alert("Please enter a valid email address");
        return;
      }
  
      try {
        await axios.post(`${baseURL}/api/send-mail`, { email });
        Swal.fire({
        icon: "success",
        title: "Success",
        text: "Email sent successfully!",
      });
      } catch (error) {
        console.error("Error sending email:", error);
        Swal.fire({
        icon: "error",
        title: "Oops!",
        text: "Failed to send email. Please try again later.",
      });
      }
    };
  return (
    <div>
      <div className="header">
        <div className="container">
          <div className="header-logo">
            <img
              src={logo}
              alt="octonius-logo"
              onClick={() => navigate("/")}
              style={{ cursor: "pointer" }}
            />
          </div>
      
          {/* Hamburger button */}
          <button className="hamburger2" onClick={toggleMenu}>☰</button>
      
          {/* Nav Menu */}
          <div className={`nav-menu2 ${menuOpen ? "open" : ""}`}>
            {/* Close button inside nav */}
            <button className="close-btn" onClick={toggleMenu}><IoMdClose /></button>
      
            <nav className={`menu2 ${location.pathname === "/" ? "active" : ""}`} onClick={() => navigate("/")}>
              Home
            </nav>
            <nav className={`menu2 ${location.pathname === "/features" ? "active" : ""}`} onClick={() => navigate("/features")}>
              Features
            </nav>
            <nav className={`menu2 ${location.pathname === "/pricing" ? "active" : ""}`} onClick={() => navigate("/pricing")}>
              Pricing
            </nav>
            <nav className={`menu2 ${location.pathname === "/contact" ? "active" : ""}`} onClick={() => navigate("/contact")}>
              Contact
            </nav>
      
            <div className="free-login" style={{color:"#000000"}}>
              <nav className="menu" onClick={() => window.open("https://app.revenuintel.com", "_blank")}>
  Login
</nav>
              <button className="log-btn" onClick={() => {navigate("/free-trial"); window.scrollTo(0, 0); }}>
                Free Trial <span className="btn-icon"><BiRightArrowAlt /></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    <div className='contact-page'>
                   <div className='contact-head1'>
                   Let's Talk About Your Business
                 </div>
                 <div className='contact-head2'>Let us know how we can help</div>
                
            
        </div>
         <div className='contact-containers'>
         <div className='con-container'>
                    <div className='image2'>
                 <img src={locationimg} alt="location" style={{marginLeft:"10px", width:"30px", height:"30px"}} />
                  </div>
                     <div className='img-text2'> Location </div>
                  <div className='contact-location'>
               No: 11, West, Ground Floor, 1st cross   <br />
             Natarajapuram North, Sundaram  <br /> Nagar,M.C Road, Thanjavur- 613007
                  </div>
                  </div>    
                  <div className='con-container'>
                    <div className='image2'>
                 <img src={phone} alt="phone" style={{marginLeft:"10px", width:"30px", height:"30px"}} />
                  </div>
                     <div className='img-text2'> Mail Us </div>
                  <div className='contact-mail'>
                support@revenuintel.com
                  </div>
                  </div>    
                  <div className='con-container'>
                    <div className='image2'>
                 <img src={chat} alt="chat" style={{marginLeft:"10px", width:"30px", height:"30px"}} />
                  </div>
                     <div className='img-text2'> Chat Support </div>
                     <div>
                      <div style={{fontSize:"12px",fontWeight:"500", color:" #767676",  marginTop: "20px",  marginLeft: "20px"}}>
                        we are here to help you
                      </div>
                  <div className='contact-mail'>
                  support@revenuintel.com
                  </div>
                  </div>
                  </div>    
               </div>
               <div className='lead-generating'>
                             <span className="lead-text">Start generating B2B leads today!</span>
                              <button className='demo-btn-talk' onClick={() => {navigate("/pricing"); window.scrollTo(0, 0); }}>Pricing  <span className="btn-icon"><BiRightArrowAlt /> </span></button>
                            </div>
                           
                            <div className='landing-6'>
                             <BiSolidQuoteAltLeft style={{marginLeft:"21%",marginTop:"40px"}} />
                            <div className='content-9'>
                            Good Insights for IT startups that serves the best for our Inside Sales team.
                            <br /> I 'would love to recommend to my clients &nbsp; <BiSolidQuoteAltRight style={{fontSize:"15px"}}/>  </div> 
                           
                             <div style={{marginLeft:"100px", marginTop:"10px", color:"black", fontWeight:"700", textAlign:"center", fontSize:"12px"}} >
                              <img src={maskphoto2} alt="maskphoto"  width="50px"/> <br />Erhan Eren <div style={{fontWeight:"500"}}>Founder and CEO, Enkiai.com</div></div>  
                           
              
                            </div>
                        <div className="curved-footer-wrapper">
                <div className="footer-image-container">
                  <img src={curve} alt="curve" className="footer-curve-img" />
                  <div className="landing-7">
                    <div className="land-contents-10">
                      We’d love to hear from you <br />
                      <span className="land-content-11" style={{marginTop:"20px"}}>support@revenuintel.com</span><br />
                     
                    </div>
                    <div className="land-contents-11">
                      Get Revenuintel Today <br />
                      <div style={{ position: "relative", display: "flex", alignItems: "center", marginTop: "40px" }}>
                <input type="email" placeholder='Business mail' className='mail-input' value={email}
        onChange={(e) => setEmail(e.target.value)} />
                <button className="mail-price-btn" onClick={handlePricingClick}>Pricing</button>
              </div>
              
                      
                    </div>
                    <div className="land-contents-13" style={{fontWeight:"500"}}>
                      Powered by, <br />
                      Merkat Intellekt Technologies <br />
                      <span className="land-content-15">Private Limited</span>
                    </div>
                  </div>
                </div>
              </div>
                 {showBanner && (
                                                  <div className='cookies'>
                                                     <div className='cookie-text'>This website uses cookies to improve your experience. We'll assume you're ok with this, but you can opt-out if you wish</div>
                                                  <div className='cookie' style={{cursor:"pointer"}} onClick={cookiePopup}>Cookie Settings</div>
                                                  <div> <button className="cookie-btn" onClick={handleAccept}>Accept</button></div>
                                                  </div> )}
                                            {showpopup && (
                             <div className="overlay">
                               <div className="privacy-popup">
                                 <div className="privacy-overview">
                                   <div className="popup-header">Privacy Overview</div>
                                   <div className='privacy-close' onClick={handleClose}><IoIosClose /></div>
                                 </div>
                                <div className="privacy-content">
                                 {isExpanded ? content : `${content.substring(0, 200)}...`}
                                 <span
                                   className="privacy-content-span"
                                   onClick={toggleReadMore}
                                   style={{ color: "blue", cursor: "pointer", marginLeft: "5px" }}
                                 >
                                   {isExpanded ? " See Less" : " See More"}
                                 </span>
                               </div>
                              <div className="privacy-neccessary">
                                 <div className="neccessary-head" >
                                   <div className="neccessary-text" onClick={toggleContent}>
                                     <RiArrowDropDownLine
                                       style={{
                                         fontSize: "35px",
                                         transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                                         transition: "transform 0.3s ease"
                                       }}
                                     />{" "}
                                     Necessary
                                   </div>
                                   <div className="neccessary-text">Always Enabled</div>
                                 </div>
                           
                                 {isOpen && (
                                   <div className="neccessary-content">
                                     Necessary cookies are absolutely essential for the website to
                                     function properly. This category only includes cookies that ensure
                                     basic functionalities and security features of the website. These
                                     cookies do not store any personal information.
                                   </div>
                                 )}
                               </div>
                                <div className="privacy-neccessary">
                                 <div className="neccessary-head" >
                                   <div className="neccessary-text" onClick={toggleContent2}>
                                     <RiArrowDropDownLine
                                       style={{
                                         fontSize: "35px",
                                         transform: isOpen2 ? "rotate(180deg)" : "rotate(0deg)",
                                         transition: "transform 0.3s ease"
                                       }}
                                     />{" "}
                                    Non-Necessary
                                   </div>
                                   <div> <CustomSwitch checked={nonNecessaryEnabled}
                                         onChange={(e) => setNonNecessaryEnabled(e.target.checked)} /></div>
                                 </div>
                           
                                 {isOpen2 && (
                                   <div className="neccessary-content">
                                    Any cookies that may not be particularly necessary for the website to function
                                     and is used specifically to collect user personal data via analytics, ads, other embedded 
                                     contents are termed as non-necessary cookies. It is mandatory to procure user consent prior
                                      to running these cookies on your website.
                                   </div>
                                 )}
                               </div>
                               <div className='privacy-save'>
                                 <button className='privacy-save-btn' onClick={handleSaveExit}>Save & Exit</button>
                               </div>
                               </div>
                             </div>
                           )}
                
    </div>
  )
}

export default LandContact;